/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { setPagination } from "../../../utils/helpers/pagination";

export default {
  SET_LIST(state, data) {
    state.list = data.items;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  SET_DETAIL(state, dayoff) {
    state.selecting = dayoff;
  },
  ADD_DAYOFF(state, dayoff) {
    state.list.push(dayoff);
  },
  UPDATE_DAYOFF(state, dayoff) {
    const index = state.list.findIndex((u) => u.id === dayoff.id);
    if (index >= 0) {
      state.list.splice(index, 1, dayoff);
    }
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
  REMOVE_RECORD(state, itemId) {
    const index = state.list.findIndex((u) => u.id === itemId);
    state.list.splice(index, 1);

    state.pagination = setPagination(state.pagination, itemId);
  },
};
